import { use } from 'react';
import { LocalizedPageUrlContext } from './LocalizedPageUrlProvider';

export const useLocalizedPageUrl = () => use(LocalizedPageUrlContext);
